import './style.scss'

interface Iprops {
  verticalMargin?: 's' | 'l' | 'x' | 'xl'
}
export const DividerLine: React.FC<Iprops> = ({ verticalMargin }) => {
  return <div className={`DividerLine ${verticalMargin}`}></div>
}
